<div class="modal-container">
  <div class="modal-content" [ngClass]="{ 'edit-item-qty': isEditQty }">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{ translatables.modalTitle | cxTranslate }}</h4>
      <button type="button" class="btn-close close" (click)="closeModal('Cross click')">
        <mat-icon svgIcon="modal-x-icon"></mat-icon>
      </button>
    </div>
    <div class="modal-desc" *ngIf="translatables.modalDesc">
      <p>{{ translatables.modalDesc | cxTranslate }}</p>
    </div>

    <form [formGroup]="cancelEditForm" (ngSubmit)="onSubmit()">
      <!-- Cancel Item/s Form Controls -->
      <ng-container *ngIf="isCancelItems">
        <ng-container *ngIf="cancelOrderReasons$ | async as cancelOrderReasons; else formSpinner">
          <div class="cancel-items-form">
            <mat-form-field [hideRequiredMarker]="true">
              <mat-label>{{ 'modal.cancellationReason' | cxTranslate }}</mat-label>
              <mat-select
                formControlName="cancellationReason"
                disableOptionCentering
                panelClass="cancellation-reason-select"
              >
                <mat-option *ngFor="let reason of cancelOrderReasons.enums" [value]="reason.code">
                  {{ reason.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>
      </ng-container>

      <!-- Edit Item Form Controls -->
      <ng-container *ngIf="isEditQty">
        <div class="edit-qty-form">
          <!-- Product Image -->
          <div class="edit-qty-form-image">
            <cx-media
              [container]="data.image"
              format="product"
              [class.is-missing-fish]="businessType === 'fish'"
            ></cx-media>
          </div>

          <!-- Product Details -->
          <div class="edit-qty-form-product-details">
            <label>{{ data.code }}</label>
            <span class="name">{{ data.name }}</span>
            <ng-container *ngIf="data.globalVariant">
              <ng-container *ngFor="let variant of data.globalVariant; let index = index; let last = last">
                <span class="global-variant">{{ variant.parentCategoryName }}: {{ variant.name }}</span>
                <span class="global-variant" *ngIf="!last">;&nbsp;</span>
              </ng-container>
            </ng-container>
          </div>

          <!-- Product Dealer Price -->
          <div class="edit-qty-form-dealer-price" *ngIf="!showSrp">
            <label>{{ 'orders.dealerPrice' | cxTranslate }}</label>
            <span class="dealer-price">
              {{ data.dealerPrice
              }}<span class="gst-label" *ngIf="data.dealerPrice && data.showGstExclusive$ | async">{{
                'gst.exclusive' | cxTranslate
              }}</span>
            </span>
          </div>

          <!-- Product Quantity Ordered -->
          <div class="edit-qty-form-qty">
            <label>{{ 'orders.quantity' | cxTranslate }}</label>
            <input type="number" formControlName="qty" (input)="onInput(qty)" />
            <mat-error *ngIf="qty.hasError('quantityExceed')">
              {{ 'orders.creditCardErrorMessageQTY' | cxTranslate }}
            </mat-error>
          </div>
        </div>
      </ng-container>

      <!-- Modal CTAs -->
      <div class="modal-cta" [ngClass]="{'edit-item-qty': isEditQty, 'cancel-order-item': isCancelItems, }">
        <button type="button" class="secondary-btn" (click)="closeModal('Cross click')">
          {{ isCancelItems ? ('modal.close' | cxTranslate) : ('common.cancel' | cxTranslate) }}
        </button>
        <button type="submit" class="primary-btn" [disabled]="cancelEditForm.invalid || cancelEditForm.pristine">
          {{ isCancelItems ? ('modal.submitCancellation' | cxTranslate) : ('common.save' | cxTranslate) }}
        </button>
      </div>
    </form>

    <ng-template #formSpinner>
      <div class="form-spinner d-flex justify-content-center m-4">
        <mat-spinner [diameter]="25"></mat-spinner>
      </div>
    </ng-template>

    <div class="overlay-spinner" *ngIf="isLoading">
      <div class="center-spinner">
        <mat-spinner [diameter]="50"></mat-spinner>
      </div>
    </div>
  </div>
</div>
